import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  Stack,
  Alert,
  useTheme,
  IconButton,
  Button,
} from "@mui/material";
import {
  WarningAmber as WarningIcon,
  DeleteForever as DeleteIcon,
  Close as CloseIcon,
  Info as InfoIcon,
} from "@mui/icons-material";

const DeleteScheduleDialog = ({
  scheduleDeleteTarget,
  setScheduleDeleteTarget,
  scheduleDeleting,
  confirmScheduleDelete,
}) => {
  const theme = useTheme();
  const open = Boolean(scheduleDeleteTarget);

  return (
    <Dialog
      open={open}
      onClose={() => !scheduleDeleting && setScheduleDeleteTarget(null)}
      PaperProps={{
        sx: {
          borderRadius: 3,
          minWidth: 400,
          boxShadow: "0 20px 40px rgba(0,0,0,0.2)",
          overflow: "visible",
        },
      }}
    >
      {/* 1. 头部：警示风格 */}
      <Box
        sx={{
          p: 2.5,
          bgcolor: "error.lighter", // 浅红色背景
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderTopLeftRadius: "inherit",
          borderTopRightRadius: "inherit",
        }}
      >
        <Stack direction='row' spacing={1.5} alignItems='center'>
          <Box
            sx={{
              p: 1,
              bgcolor: "error.main",
              borderRadius: "50%",
              display: "flex",
              color: "white",
            }}
          >
            <WarningIcon fontSize='small' />
          </Box>
          <Typography variant='h6' fontWeight={700} color='error.main'>
            Delete Schedule
          </Typography>
        </Stack>
        <IconButton
          onClick={() => setScheduleDeleteTarget(null)}
          disabled={scheduleDeleting}
          sx={{ color: "error.main" }}
          size='small'
        >
          <CloseIcon />
        </IconButton>
      </Box>

      <DialogContent sx={{ p: 3, pt: 2 }}>
        <Stack spacing={2}>
          <Typography variant='body1' color='text.primary'>
            Are you sure you want to permanently remove this schedule?
          </Typography>
        </Stack>
      </DialogContent>

      {/* 4. 底部操作 */}
      <DialogActions sx={{ p: 3, pt: 0 }}>
        <Box sx={{ display: "flex", gap: 1.5, width: "100%" }}>
          <Button
            onClick={() => setScheduleDeleteTarget(null)}
            disabled={scheduleDeleting}
            fullWidth
            variant='outlined'
            sx={{ borderRadius: 2, py: 1.2 }}
          >
            Cancel
          </Button>
          <Button
            color='error'
            variant='contained'
            onClick={confirmScheduleDelete}
            disabled={scheduleDeleting}
            startIcon={scheduleDeleting ? null : <DeleteIcon />}
            fullWidth
            sx={{
              borderRadius: 2,
              py: 1.2,
              bgcolor: "error.main",
              "&:hover": { bgcolor: "error.dark" },
            }}
          >
            {scheduleDeleting ? "Deleting..." : "Yes, Delete"}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteScheduleDialog;
